import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import SectionsInfo from '../components/SectionsInfo';
import earlyOneIcon from '../assets/icons/earlyOne.png';
import mapPointIcon from '../assets/icons/mapPoint.svg';
import phoneIcon from '../assets/icons/phoneGray.svg';
import mailIcon from '../assets/icons/emailGray.svg';
import Spinner from '../components/Spinner';
import { getAddressesPage } from '../store/actions/addressesPage';
import removeHtmlTags from '../helpers/removeHtmlTags';
import CustomMap from '../components/CustomMap';
import { getBranchSchema } from '../utils/schema';

function Addresses() {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.addressesPage);
  const [center, setCenter] = useState({ lat: 40.1817, lng: 44.5099 });
  const [zoom] = useState(17);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const addressId = queryParams.get('address');

  useEffect(() => {
    dispatch(getAddressesPage());
  }, []);

  const handleChangeMap = (lat, lng) => {
    mapRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setCenter({ lat: +lat, lng: +lng });
  };
  const { translations } = useSelector((state) => state.translation);
  useEffect(() => {
    if (addressId) {
      const element = data?.address?.find((e) => e.id === +addressId);
      if (element) {
        handleChangeMap(element.latitude, element.longitude);
      }
    }
  }, [addressId, data]);
  // Schema 3: one LocalBusiness / MedicalOrganization block per branch.
  const branchesSchema = (data.address || [])
    .map((branch) => getBranchSchema(branch, lang))
    .filter(Boolean);
  if (loading) {
    return (
      <Wrapper>
        <Spinner width={100} height={100} />
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      {branchesSchema.length > 0 && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(branchesSchema)}
          </script>
        </Helmet>
      )}
      <div className="addresses">
        <div className="container medium">
          <div ref={mapRef} className="map">
            {data.address && data.address.length > 0 && (
            <CustomMap mapRef={mapRef} zoom={zoom} center={center} data={data.address} />
            )}
          </div>
          <div className="addresses__content">
            <SectionsInfo
              isSlider={false}
              isPartner={false}
              title={data.ourAddresses?.two_blog_title[lang]}
              description={removeHtmlTags(data.ourAddresses?.two_blog_description[lang])}
            />
            <div className="addresses__content-list">
              {data.address?.map((e) => (
                <figure key={e.id} className="address_card">
                  <img src={e.image.webp_url} alt={e?.image?.alt_attribute[lang]} />
                  <figcaption className="address_card-info">
                    <div className="address_card-info-main">
                      <p className="address_card-info-main-title">{e.address[lang]}</p>
                      <p className="address_card-info-main-type">{+e.is_main === 1 ? translations.main_office[lang] : translations.laboratory[lang]}</p>
                    </div>
                    <div className="addresses_card-cotacts">
                      {e.email && (
                      <a href={`mailto:${e.email}`}>
                        <img src={mailIcon} alt="mail" />
                        <p>{e.email}</p>
                      </a>
                      )}
                      {e.phone && (
                      <a href={`tel:${e.phone}`}>
                        <img src={phoneIcon} alt="mail" />
                        <p>{e.phone}</p>
                      </a>
                      )}
                      {e.mobile && (
                      <a href={`tel:${e.mobile}`}>
                        <img src={phoneIcon} alt="mail" />
                        <p>{e.mobile}</p>
                      </a>
                      )}
                    </div>
                    <div className="addresses_card-actions">
                      {+e.has_booking === 1 && (
                      <button style={{ cursor: 'inherit' }} className="addresses_card-actions-early" type="button">
                        <img src={earlyOneIcon} alt="early one" />
                        <p>Early one</p>
                      </button>
                      )}
                      <button onClick={() => handleChangeMap(e.latitude, e.longitude)} className="addresses_card-actions-map" type="button">
                        <img src={mapPointIcon} alt="" />
                        <p>{translations.shop_on_map[lang]}</p>
                      </button>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Addresses;
